import { Injectable } from '@angular/core';
import Swal, {SweetAlertIcon} from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor() { }

  public success(title: string, message: string): void {
    this.modalAlert(title, message,'success')
  }

  public error(title: string, message: string): void {
    this.modalAlert(title, message,'error')
  }

  public warning(title: string, message: string): void {
    this.modalAlert(title, message,'warning')

  }

  public modalAlert(
    title: string,
    html: string,
    icon: SweetAlertIcon,
  ) {
    Swal.fire(
      title,
      html,
      icon
    )
  }

  public loadingAlert(title: string, text?: string) {
    Swal.fire({
      title: title,
      html: text,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }

  public close() {
    Swal.close();
  }
}
